const pictograms = {
  resources: (<><path d="M3.5 5.5c3-1.6 5.9-1.6 8.5 0 2.6-1.6 5.5-1.6 8.5 0V20c-3-1.6-5.9-1.6-8.5 0-2.6-1.6-5.5-1.6-8.5 0z" /><path d="M12 5.5V20" /></>),
  quizzes: (<><rect x="5" y="3" width="14" height="18" rx="2" /><path d="m8.5 10.5 2.2 2.2 4.7-4.7M8.5 17h7" /></>),
  simulations: (<><circle cx="12" cy="13" r="8" /><path d="M12 9v4l3 2M9 2h6" /></>),
  announcements: (<><path d="M4 13v-2l11-4v10L4 13Z" /><path d="M15 10.5h2.5a2.5 2.5 0 0 1 0 5H15M6.5 14l1.2 5H10" /></>),
};
export default function PathIcon({ name }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false">
      {pictograms[name] || pictograms.resources}
    </svg>
  );
}
